<template>
  <div id="GPA">
    <v-expansion-panels v-if="savedSchool.gpa_minimum_required" focusable  class="px-2">
      <v-expansion-panel  class="mt-4"  >
        <v-expansion-panel-header class="light-blue--text text--darken-4" >
          <v-layout row align-center>

            <v-icon v-if="!hasCompletedAllGpaRequirements" color="red">mdi-check-circle</v-icon>
            <v-icon v-else color="green">mdi-check-circle</v-icon>
            <v-icon color="blue darken-3 " class="ml-2">mdi-format-annotation-plus</v-icon>
            <span class="ml-2 blue--text text--darken-3 font-weight-medium">GPA</span>
          </v-layout>

        </v-expansion-panel-header>
        <v-expansion-panel-content  class="mt-3 px-0 mx-0 pb-0 elevation-0" >

          <!-- GPA Values and Conditions Container -->
            <v-card  style="borderRadius:5px" class=" innerCardCover" id="buttonShadow">
              <v-layout v-if="savedSchool.gpa_minimum_required === true && !hasCompletedGPARequirement" justify-center class="pb-2 red" >
                <span class="white--text text-center mt-2">Minimum <span v-if="savedSchool.caspa_participant"> CASPA</span> GPA Pending</span>
              </v-layout>
              <v-layout v-else justify-center class=" green pb-2">
                <span class="white--text text-center mt-2">Minimum  <span v-if="savedSchool.caspa_participant"> CASPA</span> GPA Completed</span>
              </v-layout>

              <v-tabs
              v-model="gpaTab"
              background-color="transparent"
              color="basil"
              grow
              class="mt-3 px-2"
              hide-slider
              >
              <v-tab active-class="grey darken-2 white--text"  style="marginLeft:0px;">
                Required GPA
              </v-tab>

              <v-tab active-class="primary white--text">
                <v-icon small class="mr-2" >mdi-account-circle</v-icon>
                <span v-if="savedSchool.caspa_participant"> My CASPA GPA</span>
                <span v-else> My GPA</span>
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="gpaTab">
              <!-- Required GPA -->
              <v-tab-item class="pb-2">
                <v-layout  v-if="savedSchool.gpa_minimum_required === true" mt-3 mb-2 align-center justify-space-around>
                      <v-layout v-if=" savedSchool.gpa_overall_minimum === '' && savedSchool.gpa_science_minimum === '' && savedSchool.gpa_prerequisite_minimum === ''" align-center justify-center mb-2>
                        <span class="grey--text">Minimum GPA Not Listed</span>
                      </v-layout>
                      <!-- Overall GPA -->
                      <v-layout v-if="savedSchool.gpa_overall_minimum !== ''" column align-center>
                          <v-progress-circular :width="3" size="80" :value=100 color="grey"> <span class="percentageValue headline font-weight-medium " :class="{'green--text': completedOverallGPA, 'red--text' : !completedOverallGPA }">{{savedSchool.gpa_overall_minimum}}</span></v-progress-circular>
                          <v-layout  align-center class="mt-2">
                            <span class="font-weight-light">Overall</span>
                          </v-layout>
                      </v-layout>
                      <!-- Science GPA -->
                      <v-layout v-if="savedSchool.gpa_science_minimum !== ''" column align-center>
                        <v-progress-circular :width="3" size="80" :value=100 color="grey"> <span class="percentageValue  headline font-weight-medium" :class="{'green--text': completedScienceGPA, 'red--text' : !completedScienceGPA }">{{savedSchool.gpa_science_minimum}}</span></v-progress-circular>
                        <v-layout  align-center class="mt-2">
                          <span class=" font-weight-light">Science</span>
                        </v-layout>

                      </v-layout>

                      <!-- Prerequiste GPA -->
                      <v-layout v-if="savedSchool.gpa_prerequisite_minimum !== ''" column align-center>
                        <v-progress-circular :width="3" size="80" :value=100 color="grey"> <span class="percentageValue  headline  red--text font-weight-medium " :class="{'green--text': completedPrerequisiteGPA, 'red--text' : !completedPrerequisiteGPA }">{{savedSchool.gpa_prerequisite_minimum}}</span></v-progress-circular>
                        <v-layout  align-center class="mt-2">
                          <span class=" font-weight-light">Prerequisite</span>
                        </v-layout>
                      </v-layout>
                </v-layout >
                <!-- CASPA GPA Calculation CARD -->
                <v-card
                  v-if="savedSchool.caspa_calculation_method !== undefined && savedSchool.caspa_calculation_method !== null && savedSchool.caspa_calculation_method[0] !== 0 "
                  style="borderRadius:5px" outlined class="mt-4 mx-2"
                  >
                    <v-layout v-if="savedSchool.caspa_participant" justify-center class=" grey lighten-3 pb-2 ">
                      <span class="subtitle-1 mt-2 font-weight-regular"> CASPA GPA Evaluated </span>
                      <v-icon @click="showCaspaCalulationMethod = true" small class=" ml-2">mdi-information</v-icon>
                    </v-layout>
                    <v-layout v-else justify-center class=" grey lighten-3 pb-2 ">
                      <span class="subtitle-1 mt-2 font-weight-regular"> College GPA Evaluated </span>
                    </v-layout>

                  <v-card-text class="pt-2  ">
                    <v-layout  v-for="calMethod in savedSchool.caspa_calculation_method" :key="calMethod.index" column class="pl-0 ml-0 ">

                        <v-layout v-if="calMethod === 'overall'" mt-2 row   align-center justify-space-between mx-0>
                          <span class=" font-weight-light black--text ">Overall GPA </span>
                          <v-icon color="blue darken-3" class="" size="20px">mdi-check-circle</v-icon>
                        </v-layout>
                        <v-divider v-if="calMethod === 'overall'"  class="mt-2 mb-1 "></v-divider>

                        <v-layout v-if="calMethod === 'science'" mt-2 row   align-center justify-space-between mx-0>
                          <span class="font-weight-light black--text">Science GPA </span>
                          <v-icon color="blue darken-3" class="" size="20px">mdi-check-circle</v-icon>
                        </v-layout>
                        <v-divider v-if="calMethod === 'science'"  class="mt-2 mb-1 "></v-divider>

                        <v-layout v-if="calMethod === 'last 30 credits'" mt-2 row   align-center justify-space-between mx-0>
                          <span class="font-weight-light black--text">Last 30 credits GPA </span>
                          <v-icon color="blue darken-3" class="" size="20px">mdi-check-circle</v-icon>
                        </v-layout>
                        <v-divider v-if="calMethod === 'last 30 credits'"  class="mt-2 mb-1 "></v-divider>

                        <v-layout v-if="calMethod === 'last 30 science credits'" mt-2 row   align-center justify-space-between mx-0>
                          <span class="black--text font-weight-light">Last 30 science credits GPA </span>
                          <v-icon color="blue darken-3" class="" size="20px">mdi-check-circle</v-icon>
                        </v-layout>
                        <v-divider v-if="calMethod === 'last 30 science credits'"  class="mt-2 mb-1 "></v-divider>

                        <v-layout v-if="calMethod === 'last 60 credits'" mt-2 row   align-center justify-space-between mx-0>
                          <span class="black--text font-weight-light">Last 60 credits GPA </span>
                          <v-icon color="blue darken-3" class="" size="20px">mdi-check-circle</v-icon>
                        </v-layout>
                        <v-divider v-if="calMethod === 'last 60 credits'"  class="mt-2 mb-1 "></v-divider>

                  </v-layout>

                  </v-card-text>
                </v-card>

                <!-- DIALOG CASPA GPA CALCULATION INFO -->
                <v-dialog
                  v-model="showCaspaCalulationMethod"
                  scrollable
                  max-width="400"
                  persistent
                  style="zIndex:2000"
                  >

                  <v-card style="borderRadius:5px">
                    <v-card-title class="title grey lighten-2 text-xs-center mb-2">
                      CASPA GPA Calculation
                    </v-card-title>
                    <v-card-text class="text-xs-justify" >
                      A CASPA GPA varies from the traditional GPA. PA programs with minimum GPA requirements request specific GPA’s calculated by CASPA. Some may require an overall GPA, while others require an overall, science, and last 60 credits GPA. CASPA will provide the exact GPA or GPA’s the PA savedSchool has set as a minimum once all of your information is verified.
                      You can read more information regarding the CASPA GPA calculation formula by clicking the following link.<a class="ml-1" href="https://help.liaisonedu.com/CASPA_Applicant_Help_Center/Submitting_and_Monitoring_Your_CASPA_Application/Verification_and_GPA_Calculations_for_CASPA/2_How_Your_GPA_is_Calculated">CASPA GPA calculation formula. </a>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn @click="showCaspaCalulationMethod= false" block color="red" class="elevation-0" dark >Close</v-btn>
                    </v-card-actions>
                  </v-card>

                </v-dialog>

                <!-- GPA CONDITIONS CARD -->
                <v-card
                  v-if="savedSchool.last_30credits_science_gpa_minimum !== '' && savedSchool.last_30credits_science_gpa_minimum !== undefined
                  || savedSchool.last_40credits_science_gpa_minimum !== '' && savedSchool.last_40credits_science_gpa_minimum !== undefined
                  || savedSchool.last_45credits_gpa_minimum !== '' && savedSchool.last_45credits_gpa_minimum !== undefined
                  || savedSchool.last_60credits_gpa_minimum !== '' && savedSchool.last_60credits_gpa_minimum !== undefined
                  || savedSchool.gpa30_better_courses[0] !== 0 && savedSchool.gpa30_better_courses[0] !== undefined"
                  class=" mt-5 mb-2 mx-2 " outlined style="borderRadius:5px"
                  >
                  <v-layout justify-center class=" grey lighten-3 pb-2 ">
                      <span block flat class="mt-2 red--text"> Other Required GPA Conditions </span>
                  </v-layout>


                  <v-card-text class="pt-2  ">
                    <v-layout column class="pl-0 ml-0 ">
                      <!-- Science GPA Minimum for last 30 credits -->
                      <v-layout  v-if="savedSchool.last_30credits_science_gpa_minimum !== '' && savedSchool.last_30credits_science_gpa_minimum !== undefined" mt-2 row   align-center justify-space-between mx-0>
                        <v-layout >
                          <v-icon class="mr-2" small color="green" v-if="getGPACheckCondition(30, savedSchool.last_30credits_science_gpa_minimum, filterScienceCourse)">mdi-check-circle</v-icon>
                          <v-icon class="mr-2" small color="red" v-else>mdi-check-circle</v-icon>
                          <span class=" font-weight-light black--text ">Science GPA for last  <span class="font-weight-regular">30 credits</span></span>
                        </v-layout>
                        <span class="blue--text text--darken-3 font-weight-medium">{{savedSchool.last_30credits_science_gpa_minimum}}</span>
                      </v-layout>
                      <v-divider  v-if="savedSchool.last_30credits_science_gpa_minimum !== '' && savedSchool.last_30credits_science_gpa_minimum !== undefined" class="mt-2 mb-1 "></v-divider>


                      <!-- Science GPA Minimum for last 40 credits -->
                      <v-layout  v-if="savedSchool.last_40credits_science_gpa_minimum !== '' && savedSchool.last_40credits_science_gpa_minimum !== undefined" mt-2 row   align-center justify-space-between mx-0>
                        <v-layout >
                          <v-icon class="mr-2" small color="green" v-if="getGPACheckCondition(40, savedSchool.last_40credits_science_gpa_minimum, filterScienceCourse)">mdi-check-circle</v-icon>
                          <v-icon class="mr-2" small color="red" v-else>mdi-check-circle</v-icon>
                          <span class=" font-weight-light black--text ">Science GPA for last  <span class="font-weight-regular">40 credits</span></span>
                        </v-layout>
                        <span class="blue--text text--darken-3 font-weight-medium">{{savedSchool.last_40credits_science_gpa_minimum}}</span>
                      </v-layout>
                      <v-divider  v-if="savedSchool.last_40credits_science_gpa_minimum !== '' && savedSchool.last_40credits_science_gpa_minimum !== undefined" class="mt-2 mb-1 "></v-divider>


                      <!-- Science GPA Minimum for last 45 credits -->
                      <v-layout  v-if="savedSchool.last_45credits_gpa_minimum !== '' && savedSchool.last_45credits_gpa_minimum !== undefined" mt-2 row   align-center justify-space-between mx-0>
                        <v-layout>
                          <v-icon class="mr-2" small color="green" v-if="getGPACheckCondition(45, savedSchool.last_45credits_gpa_minimum)">mdi-check-circle</v-icon>
                          <v-icon class="mr-2" small color="red" v-else>mdi-check-circle</v-icon>
                          <span class=" font-weight-light black--text ">Science GPA for last  <span class="font-weight-regular">45 credits</span></span>
                        </v-layout>
                        <span class="blue--text text--darken-3 font-weight-medium">{{savedSchool.last_45credits_gpa_minimum}}</span>
                      </v-layout>
                      <v-divider  v-if="savedSchool.last_45credits_gpa_minimum !== '' && savedSchool.last_45credits_gpa_minimum !== undefined" class="mt-2 mb-1 "></v-divider>


                      <!-- Overall GPA LAST 60 CREDITS -->
                      <v-layout  v-if="savedSchool.last_60credits_gpa_minimum !== '' && savedSchool.last_60credits_gpa_minimum !== undefined" mt-2 row   align-center justify-space-between mx-0>
                        <v-layout >
                            <v-icon class="mr-2" small color="green" v-if="getGPACheckCondition(60, savedSchool.last_60credits_gpa_minimum)">mdi-check-circle</v-icon>
                            <v-icon class="mr-2" small color="red" v-else>mdi-check-circle</v-icon>
                            <span class=" font-weight-light black--text ">Overall GPA for last  <span class="font-weight-regular">60 credits</span></span>
                        </v-layout>
                        <span class="blue--text text--darken-3 font-weight-medium">{{savedSchool.last_60credits_gpa_minimum}}</span>
                      </v-layout>
                      <v-divider  v-if="savedSchool.last_60credits_gpa_minimum !== '' && savedSchool.last_60credits_gpa_minimum !== undefined" class="mt-2 mb-1 "></v-divider>

                      <!-- GPA of 3.0 or better needed in the following courses -->
                      <v-layout v-if="savedSchool.gpa30_better_courses[0] !== 0" column class="pb-0 ">
                        <v-layout align-baseline justify-center>
                          <v-icon class="mr-2" small color="green" v-if="getGPAForCourses(3, generateCoursesFilter(savedSchool.gpa30_better_courses))">mdi-check-circle</v-icon>
                          <v-icon class="mr-2" small color="red" v-else>mdi-check-circle</v-icon>
                          <p class=" mt-2 mb-0 font-weight-light black--text">GPA of<span class="font-weight-medium blue--text text--darken-3"> 3.0 </span>or better required for following prerequisites:</p>
                        </v-layout>
                        <v-layout column v-for=" course in savedSchool.gpa30_better_courses" :key="course.id" class="mt-1 ml-9" >
                          <v-layout row align-center><span class="font-weight-regular blue--text text--darken-3 ">{{course.course_name}}</span> <span v-if="course.lab !== null && course.lab !== undefined" class="caption grey--text ml-1">{{course.lab[0]}}</span> </v-layout>
                          <v-layout>
                            <span v-if="course.credits !== '' && course.credits !== undefined" class="grey--text">{{course.credits}} credits</span>
                            <span v-if="course.semester !== '' && course.semester!== undefined" class="grey--text"> - {{course.semester}} semester hrs</span>
                            <span v-if="course.quarter !== '' && course.quarter!== undefined" class="grey--text"> - {{course.quarter}} quarter hrs</span>
                          </v-layout>

                        </v-layout>
                        <v-divider class="mt-2"></v-divider>

                      </v-layout>

                    </v-layout>
                  </v-card-text>
                </v-card>

                <!-- GPA Notes -->
                  <v-card  v-if="savedSchool.gpaNotes" outlined class=" mt-4 mb-4 mx-2">
                    <v-layout align-center justify-center class=" pb-1" > 
                      <v-icon small class="mr-2">mdi-message-text-outline</v-icon>
                      <span class="font-weight-light align-center">Additional Notes </span>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-card-text class="text-center">
                      <span>{{savedSchool.gpaNotes}}</span>
                    </v-card-text>
                  </v-card>

              </v-tab-item>
              <!-- My GPA -->
              <v-tab-item class="pb-1">
                <!-- User CASPA GPA -->
                <v-layout v-if="savedSchool.caspa_participant"row align-center mt-3 mb-2 justify-space-around >
                    <!-- Overal CASPA GPA -->
                    <v-layout v-if="savedSchool.gpa_overall_minimum" column align-center>
                      <v-progress-circular :width="3" size="80" :value=100 color="grey"> <span class="percentageValue headline font-weight-medium blue--text text--darken-3 ">{{overallCaspaGpa.toFixed(2)}}</span></v-progress-circular>
                        <v-layout  align-center class="mt-2">
                          <span class="font-weight-light">Overall</span>
                        </v-layout>
                    </v-layout>
                    <!-- Science CASPA GPA -->
                    <v-layout v-if="savedSchool.gpa_science_minimum" column align-center>
                      <v-progress-circular :width="3" size="80" :value=100  color="grey"> <span class="percentageValue headline  blue--text text--darken-3 font-weight-medium ">{{scienceCaspaGpa.toFixed(2)}}</span></v-progress-circular>
                        <v-layout  align-center class="mt-2">
                          <span class="font-weight-light">Science</span>
                        </v-layout>
                    </v-layout>
                    <!-- Prerequisite CASPA GPA -->
                    <v-layout column align-center v-if="savedSchool.gpa_prerequisite_minimum !== ''">
                      <v-progress-circular :width="3" size="80" :value=100  color="grey"> <span class="percentageValue   headline   blue--text text--darken-3 font-weight-medium " v-html="preReqCASPAGPA.toFixed(2)"></span></v-progress-circular>
                      <v-layout  align-center class="mt-2">
                          <span class="font-weight-light">Prerequisite</span>
                        </v-layout>
                    </v-layout>
                </v-layout>

                <!-- User College GPA -->
                <v-layout v-else row align-center mt-3 mb-2 justify-space-around >
                    <v-layout v-if="savedSchool.gpa_overall_minimum" column align-center>
                      <v-progress-circular :width="3" size="80" :value=100 color="grey"> <span class="percentageValue headline font-weight-medium blue--text text--darken-3 ">{{overallGpa.toFixed(2)}}</span></v-progress-circular>
                        <v-layout  align-center class="mt-2">
                          <span class="font-weight-light">Overall</span>
                        </v-layout>
                    </v-layout>

                    <v-layout v-if="savedSchool.gpa_science_minimum" column align-center>
                      <v-progress-circular :width="3" size="80" :value=100  color="grey"> <span class="percentageValue headline  blue--text text--darken-3 font-weight-medium ">{{scienceGpa.toFixed(2)}}</span></v-progress-circular>
                        <v-layout  align-center class="mt-2">
                          <span class="font-weight-light">Science</span>
                        </v-layout>
                    </v-layout>

                    <v-layout column align-center v-if="savedSchool.gpa_prerequisite_minimum !== ''">
                      <v-progress-circular :width="3" size="80" :value=100  color="grey"> <span class="percentageValue   headline   blue--text text--darken-3 font-weight-medium " v-html="preReqGPA.toFixed(2)"></span></v-progress-circular>
                      <v-layout  align-center class="mt-2">
                          <span class="font-weight-light">Prerequisite</span>
                        </v-layout>
                    </v-layout>
                </v-layout>


              </v-tab-item>
            </v-tabs-items>



            </v-card>

        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
  import userMixins from '@/mixins/usersmixin'
  import checkGPAMixin from '@/mixins/requirementchecks/checkgpamixin'
  import checkPrerequisitesMixin from '@/mixins/requirementchecks/checkprerequisitesmixin'
  export default {
    mixins: [userMixins,checkGPAMixin, checkPrerequisitesMixin ],
    props: ['savedSchool'],
    data() {
      return {
        gpaTab: null,
        showCaspaCalulationMethod: false,
      }
    },

  }
</script>

<style scoped>
.v-expansion-panel::before {
   box-shadow: 0 10px 20px -10px rgba(0,0,0,.19)  !important;
}

.innerCardCover {
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
  border-radius: 5px;
  padding: 0;
  margin-top: 12px;
}


</style>



// WEBPACK FOOTER //
// src/components/Dashboard/SavedSchools/RequirementTracker/GPA.vue